<h2 mat-dialog-title>Make Salary Payment</h2>
<form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="salary-payment-form">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Employee</mat-label>
      <input matInput [value]="data.employeeName" readonly />
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Year</mat-label>
      <input matInput formControlName="year" readonly />
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Month</mat-label>
      <input matInput [value]="data.period" readonly />
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Amount</mat-label>
      <input matInput formControlName="amount" type="number" step="0.01" />
      <span matSuffix>£</span>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Hours Worked</mat-label>
      <input matInput formControlName="hoursWorked" type="number" step="0.01" />
      <span matSuffix>hrs</span>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Days Worked</mat-label>
      <input matInput formControlName="daysWorked" readonly />
      <span matSuffix>days</span>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Payment Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="paymentDate" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Payment Method</mat-label>
      <mat-select formControlName="paymentMethod">
        <mat-option value="BACS">BACS</mat-option>
        <mat-option value="Cash">Cash</mat-option>
        <mat-option value="Other">Other</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Reference Number</mat-label>
      <input matInput formControlName="referenceNumber" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="notes" rows="2"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="loading || paymentForm.invalid">
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <span *ngIf="!loading">Save Payment</span>
    </button>
  </mat-dialog-actions>
</form> 